import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Spinner from "../General/Spinner";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import JobDetail from "./JobDetail";
import JobTabsView from "./JobTabsView";

import {
  addPrivateElement,
  getPrivateElements,
  getPrivateElementByID,
  putPrivateElement,
  deletePrivateElement,
} from "../customHooks/FetchDataHook";
import { Container, Box } from "@mui/material";
import { set } from "react-hook-form";

export const JobViewer = (props) => {
  const [useCurrentJob, setCurrentJob] = useState(props.job);
  const [useLoading, setLoading] = useState(props.job ? false : true);
  const [useError, setError] = useState(null);
  // Cotización previa (solo para contexto B, jobs/edit). En contexto A no se usa.
  const [cotPrevia, setCotPrevia] = useState(null);
  // Si props.cot ya vino (contexto A), no hay nada que chequear: listo de entrada.
  const [cotChecked, setCotChecked] = useState(!!props.cot);
  const navigate = useNavigate();
  const params = useParams();
  const { id } = params;

  useEffect(() => {
    if (props.job !== undefined) {
      setCurrentJob(props.job);
      setLoading(false);
      setError(null);
    } else {
      try {
        const fetchJob = async () => {
          const currentJob = await getPrivateElementByID(props.entity, id);
          currentJob
            ? setCurrentJob(currentJob)
            : setError({ message: "Trabajo inexistente" });
          setLoading(false);
        };
        fetchJob();
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    }
  }, [setCurrentJob, props.job, props.entity, id]);

  // Contexto B (jobs/edit): si NO vino props.cot, buscamos la última cotización
  // previa del job y la usamos como cot. Si vino props.cot (contexto A), este
  // effect no hace nada. Pase lo que pase, marcamos cotChecked para destrabar
  // el render. Si no hay cotización previa, cot queda null y JobDetail muestra
  // el flujo de imposición a mano (vacío), tal como se acordó.
  useEffect(() => {
    if (props.cot) return; // contexto A: nada que hacer
    if (!useCurrentJob?._id) return; // todavía no tenemos el job

    const fetchCotPrevia = async () => {
      try {
        const cotizaciones = await getPrivateElements(
          `quotations/?P=jobId&Q=${useCurrentJob._id}`,
        );
        const ultima =
          Array.isArray(cotizaciones) && cotizaciones.length > 0
            ? cotizaciones[0]
            : null;
        
        setCotPrevia(ultima ? ultima.data : null);
      } catch (error) {
        console.error("Error fetching cotización previa:", error);
        setCotPrevia({data: {impositionData: props.job.ImpositionData}});
      } finally {
        setCotChecked(true);
      }
    };

    fetchCotPrevia();
  }, [props.cot, useCurrentJob]);

  const preloader = (
    <>
      <Spinner />
    </>
  );

  const output = () => {
    if (useLoading === false && useCurrentJob !== null && cotChecked) {
      const cotFinal = props.cot || cotPrevia;
      return (
        <JobDetail
          job={useCurrentJob}
          cot={cotFinal}
          key={`JobDetail_${id}`}
        />
      );
    } else {
      return preloader;
    }
  };

  return (
    <Box
      sx={{
        padding: 0,
        height: "100%",
        width: "100%",
      }}
    >
      {useError ? (
        <ErrorMessage message={useError.message} title={`Error`} />
      ) : (
        output()
      )}
    </Box>
  );
};
